module.exports = __webpack_public_path__ + "static/media/loading.d8a8020b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading.svg
// module id = 79
// module chunks = 0